import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, ShieldIcon, CrownIcon } from 'lucide-react';
const solutions = [{
  icon: <BookOpenIcon className="w-6 h-6 text-electric-blue" data-id="element-237" />,
  title: 'Lectura Corporal Total',
  description: 'Decodificá gestos, posturas y microexpresiones en tiempo real. Sabé lo que piensan antes de que hablen.'
}, {
  icon: <ShieldIcon className="w-6 h-6 text-electric-blue" data-id="element-238" />,
  title: 'Escudo Anti-Manipulación',
  description: 'Detectá tácticas de control emocional, gaslighting y engaño. Nunca más caigas en trampas psicológicas.'
}, {
  icon: <CrownIcon className="w-6 h-6 text-electric-blue" data-id="element-239" />,
  title: 'Presencia de Alto Impacto',
  description: 'Proyectá autoridad, carisma y confianza en cualquier situación. Dominá la sala sin decir una palabra.'
}];
export function SolutionSection() {
  return <section className="pt-6 pb-6 px-4 bg-[#0A0A0A] relative border-t border-white/5" data-id="element-240">
      <div className="absolute inset-0 opacity-20 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.15) 1px, transparent 1px)',
      backgroundSize: '3px 3px'
    }} data-id="element-241"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-242">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-5" data-id="element-243">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-1" data-id="element-244">
            La Solución Definitiva
          </h2>
          <p className="text-base text-smoke/80 max-w-2xl mx-auto" data-id="element-245">
            Un sistema completo de 6 tomos que te entrena para leer, detectar y
            responder — en cualquier situación.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-246">
          {solutions.map((item, index) => <div key={index} className={`animate-fade-in-up stagger-${index + 1} bg-deep-black border border-white/10 p-4 rounded-xl flex flex-col items-center text-center hover:border-electric-blue/50 hover:shadow-glow-blue transition-all duration-300 group`} data-id="element-247">
              <div className="w-11 h-11 rounded-full bg-electric-blue/10 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform" data-id="element-248">
                {item.icon}
              </div>
              <h3 className="font-heading text-lg font-bold text-white mb-2" data-id="element-249">
                {item.title}
              </h3>
              <p className="text-smoke/80 text-sm leading-relaxed" data-id="element-250">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}